'use strict';

var trackingUtils = require('../modules/utils/tracking.utils');
const duplicatedBookingErrorCode = 'SB-005';
const logger = require('od-modules/utils/logger');
const trackingPagesErrorToAvoidToBeSent = [
    'FLEXIBLE_DATES_ERROR',
    'PRECREATE_SHOPPING_CART_ERROR',
];

const shouldTrackPageView = function(errorCode, isMainBatch) {
    return !trackingPagesErrorToAvoidToBeSent.includes(errorCode) && isMainBatch !== false;
};

const trackingMessagesToAvoidToBeSent = [
    'error.validate.toManyPassengers',
    'error.validate.toManyChildren',
    'error.validate.toManyInfants',
];

const generateErrorCodeLabel = function(error) {
    var errorMessage = Odigeo._.isString(error.message) ? error.message.split(':')[0].substring(0, 35) : '';
    var errorCode = Odigeo._.isString(error.code) ? error.code.toLowerCase() : '';
    return 'error:' + errorMessage + '-code:' + errorCode;
};

const trackVirtualPage = (type, message) => {
    const isBookingFunnel = !Odigeo._.isEmpty(Odigeo.Utils.getFunnelInGlobalScope());
    trackingUtils.trackPage(Odigeo.History.getPageNameFromFragment(), {
        funnel: isBookingFunnel,
        error: {type, message},
    });
};

const getData = (xhr) => {
    let data = xhr.responseJSON;
    if (Odigeo._.isEmpty(data)) {
        try {
            data = JSON.stringify(xhr.responseText);
        } catch (error) {
            logger.error(error);
            return;
        }
    } else {
        if (data.analyticsSearchInfo) {
            Odigeo.Session.set('analyticsSearchInfo', JSON.stringify(data.analyticsSearchInfo));
        }
        Odigeo.trigger('generic:analyticsSearchInfoReady');
    }
    return data;
};

const handleGenericErrorCodes = (xhr, {
    handler,
    handleErrorCodes = () => false,
    defaultHandler,
}) => {
    switch (xhr.status) {
        case 0:
            if (xhr.statusText !== 'abort' && Odigeo.History.getPageNameFromFragment() !== 'confirmation') {
                var label = xhr.statusText === 'timeout' ? 'timeout' : '0';

                trackingUtils.trackEvent('request_errors', label, Odigeo.History.getPageNameFromFragment());
                Odigeo.UIElements.show0Error();
            }
            break;
        case 404:
            trackVirtualPage('default', '404');
            handler.error404();
            break;
        case 500:
            trackVirtualPage('default', '500');
            if (!handleErrorCodes(xhr)) {
                handler.error500();
            }
            break;
        case 501:
            trackVirtualPage('default', '501');
            if (Odigeo.SessionScope.flow === 'mobile') {
                Odigeo.trigger('sessionExpiredError:open');
            } else {
                Odigeo.UIElements.showSessionExpiredError();
            }
            break;
        default:
            defaultHandler(xhr);
    }
};

module.exports = {
    handleGenericErrorCodes,
    afterLoadData: function(xhr) {
        var data = null;
        var shouldHideLoading = true;

        const handleErrorCodes = (xhr) => {
            let errorHandled = false;
            data = getData(xhr);

            if (!data) {
                return;
            }

            if (Odigeo._.has(data, 'errors') && Odigeo._.isArray(data.errors) && data.errors.length > 0) {
                errorHandled = true;
                Odigeo._.each(data.errors, function(error) {
                    switch (error.code) {
                        case 'META_EXTERNAL_SELECTION':
                            if ('desktop' === Odigeo.SessionScope.flow) shouldHideLoading = false;
                            break;
                        // fallsthrough
                        case 'PRECREATE_SHOPPING_CART_ERROR':
                        case 'BOOKING_ERROR':
                        case 'INVALID_DESTINATION_ERROR':
                        case 'NO_ACCOMMODATION_RESULTS':
                        case 'NO_ITINERARIES_RESULTS':
                            break;
                        case 'FLEXIBLE_DATES_ERROR':
                            shouldHideLoading = false;
                            break;
                        case 'VALIDATION_ERROR':
                            Odigeo.UIElements.showValidationError(this.pagesList);
                            break;
                        case 'BROKEN_FLOW_ERROR': {
                            const path = Odigeo.History.getPageNameFromFragment();
                            const shouldShowAlternativeBrokenFlow = path.includes('checkout_flight_summary_results')
                                || path === 'xsellproductselection';

                            ((Odigeo.AB.isErrorFlightSelection && path === 'detailsloading') || shouldShowAlternativeBrokenFlow)
                                ? Odigeo.UIElements.showSelectionError(error)
                                : this.brokenFlowError(error);
                            break;
                        }
                        case 'ACCOMMODATION_POSTBOOKING_NOCONTRACT_ERROR':
                            trackingUtils.trackEventWithCategory('pb_dynpack_pay_page', 'nags', 'nag_error_booking_not_contract_status_shown');
                            Odigeo.UIElements.showNoContractBookingAccommodationPBError();
                            break;
                        case 'SEARCH_EXPIRED_ERROR':
                            Odigeo.UIElements.showSearchExpiredError();
                            break;
                        case 'SESSION_EXPIRED_ERROR':
                            this.sessionExpiredError();
                            break;
                        case 'DUPLICATED_BOOKING_ERROR':
                            Odigeo.UIElements.showBookingAlreadyDone('alert');
                            break;
                        case 'SEATMAP_SELECTION_RETRY_ERROR':
                            Odigeo.requireWidget(this.seatmapSelectionWidget.id, this.seatmapSelectionWidget.name, function(graphseatmap) {
                                graphseatmap.execute('onSeatMapSelectionRetryError', error.details);
                            });
                            break;
                        case 'ACCOMMODATION_POSTBOOKING_BOOKING_ERROR':
                            Odigeo._.contains(error.message, duplicatedBookingErrorCode) ? Odigeo.UIElements.showAlreadyUsedError()
                                : Odigeo.UIElements.showBrokenFlowError('alert', true);
                            break;
                        case 'UPDATE_BOOKING_ERROR':
                            if ('desktop' === Odigeo.SessionScope.flow) {
                                break;
                            }
                        // fallsthrough
                        default:
                            errorHandled = false;
                            this.defaultError();
                    }
                    if (shouldTrackPageView(error.code, data.mainBatch)) {
                        trackVirtualPage('default', !Odigeo._.isUndefined(error.code) ? error.code.toLowerCase() : 'error');
                    }
                    if (!Odigeo._.includes(trackingMessagesToAvoidToBeSent, error.message)) {
                        trackingUtils.trackEvent('request_errors', generateErrorCodeLabel(error));
                    }
                }, this);
            } else {
                shouldHideLoading = false;
                return errorHandled;
            }
            return errorHandled;
        };

        if (!xhr) {
            return;
        }

        handleGenericErrorCodes(xhr, {
            handler: this,
            handleErrorCodes,
            defaultHandler: handleErrorCodes,
        });

        if (shouldHideLoading) {
            this.hideLoading();
        }
    },
};
